import { RichText, withDatasourceCheck } from "@sitecore-jss/sitecore-jss-nextjs";
import { ComponentProps } from "lib/component-props";
import Image from "next/image";
import { useEffect, useRef, useState } from "react";
import Loading from "components/Shared/Loading";
import Pagination from "components/Shared/Pagination";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { Dialog, Transition } from "@headlessui/react";
// import {  Popover } from "@headlessui/react";
import { Fragment } from "react";
// import {
//   FacebookShareButton,
//   TwitterShareButton,
//   WhatsappShareButton,
//   EmailShareButton,
// } from "react-share";
import { saveAs } from "file-saver";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode, Mousewheel, Navigation, Thumbs } from "swiper";
import axios from "axios";
import 'swiper/css';

// import moment from "moment";
import IsRtl from "components/Shared/isRtl";

type CulturalLensProps = ComponentProps & {
  fields: any;
  lang: any;
  locale: any;
};
function cn(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}
gsap.registerPlugin(ScrollTrigger);
const CulturalLens = (props: CulturalLensProps): JSX.Element => {
  const itemsPerPage: number = 9;
  const [currentPage, setCurrentPage] = useState(1);
  const container = useRef<HTMLDivElement | HTMLElement | any>();

  const onPageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  let [isOpen, setIsOpen] = useState(false);
  // let [selectedItem, setSelectedItem]: any = useState(null);
  // let [shareModal, setShareModal]: any = useState(false);
  const [isImageLoading, setIsImageLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [swiper, setSwiper] = useState<any>();
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const [selectedSlide, setSelectedSlide] = useState(0);
  const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);
  const [listData, setListData] = useState<any>([]);
  const [isPlaying, setIsPlaying] = useState(false);

  const toggleAutoplay = () => {
    if (swiper) {
      if (isPlaying) {
        swiper.autoplay.stop();
      } else {
        swiper.autoplay.start();
      }
      setIsPlaying(!isPlaying);
    }
  };
  const getListData = async () => {
    try {
      const res = await axios({
        url: `${process.env.NEXT_PUBLIC_SITECORE_REST}/api/CulturalLens/Moc/Get`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          culture: props?.locale,
          order: "desc",
          PageSize: currentPage - 1,
          PageNumber: itemsPerPage,
        },
      });
      setListData(res.data);
      setLoading(false); // Update listData with the response data
      setError(false);
    } catch (error) {
      // Handle error
      setLoading(false);
      setError(true);
    }
  };
  useEffect(() => {
    getListData();
    gsap.set(".animate-top", {
      opacity: 0,
      y: 100,
    });
    ScrollTrigger.batch(".animate-top", {
      onEnter: (batch) =>
        gsap.to(batch, {
          opacity: 1,
          y: 0,
          stagger: { each: 0.2 },
          overwrite: true,
        }),
      onEnterBack: (batch) => gsap.to(batch, { opacity: 1, y: 0, stagger: 0.2, overwrite: true }),
    });
  }, [currentPage, props?.locale]);

  const handleSwiperUpdate = (swiper: any) => {
    setSwiper(swiper);
  };
  const handleSlideChange = (swiper: any) => {
    setActiveSlideIndex(swiper.realIndex);
  };
  if (loading)
    return (
      <div className="py-40">
        <div className="">
          <Loading isCardList={true} itemsPerPage={itemsPerPage} />
        </div>
      </div>
    );
  if (error)
    return (
      <>
        <div className="responsive">
          <h2>error in loading items</h2>
        </div>
      </>
    );
  function closeModal() {
    setIsPlaying(false);
    setIsOpen(false);
    setThumbsSwiper(null);
  }

  function openModal(index: number) {
    setSelectedSlide(index);
    // setSelectedItem(item);
    setIsOpen(true);
  }

  const downloadImage = async (link: string, index: any, __filename: any = "download") => {
    // const ext:any=link?.split(/[#?]/)[0].split('.')?.pop()?.trim();
    if (index == -1) {
      document.getElementById("download" + index)?.classList.add("!hidden");
      document.getElementById("loader" + index)?.classList.add("!block");
      const result = await fetch(link, {
        method: "GET",
        headers: {},
      });

      const blob = await result.blob();
      const url = URL.createObjectURL(blob);
      document.getElementById("download" + index)?.classList.remove("!hidden");
      document.getElementById("loader" + index)?.classList.remove("!block");
      saveAs(url, __filename);
    } else {
      document.getElementById("download" + index)?.classList.add("!hidden");
      document.getElementById("loader" + index)?.classList.add("!block");
      const result = await fetch(link, {
        method: "GET",
        headers: {},
      });

      const blob = await result.blob();
      const url = URL.createObjectURL(blob);
      document.getElementById("download" + index)?.classList.remove("!hidden");
      document.getElementById("loader" + index)?.classList.remove("!block");
      saveAs(url, __filename);
    }
  };

  return (
    <div ref={container} className={`${IsRtl() ? 'rtl': 'ltr'}  w-full pb-20`}>
      <div className='w-full bg-[#F7FDF9] pb-20 mb-6'>
        <h1 className="responsive animate-top text-brand-400   xl:text-4xl text-2xl font-bold ">{props?.fields?.title?.value}</h1>
      </div>
    <div  className="h-full responsive ">
      <div className={`${props?.locale == props?.lang ? "rtl" : ""}`}>
        <RichText className="text-description py-8 p-space" field={props?.fields?.description} />
      </div>

      <div className=" ">
        <div
          className={`grid  xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-12 mb-20 ${
            props?.locale == props?.lang ? "rtl" : ""
          }`}
        >
          {!loading &&
            !error &&
            listData?.CulturalLens?.map((items: any, index: number) => {
              return (
                <div
                  className={`border-neutral-300 border rounded-xl  p-4 cursor-pointer group relative z-10 flex flex-col justify-between ${
                    props?.locale == props?.lang ? "rtl " : ""
                  } animate-top  col-span-1`}
                  key={index}
                  onClick={() => {
                    openModal(index);
                  }}
                >
                  <div>
                    <div className="relative min-h-[280px] h-lg:min-h-[360px] rounded-md overflow-hidden cursor-pointer z-0">
                      <Image
                        src={process.env.NEXT_PUBLIC_SITECORE_API_HOST + items.image}
                        alt={items?.description?.value || items?.title?.value || `Cultural lens image ${index + 1}`}
                        layout="fill"
                        objectFit="cover"
                        objectPosition="center"
                        loading="eager"
                        className={cn(
                          "bg-brand-1600 duration-700 ease-in-out sm:group-hover:scale-110",
                          isImageLoading
                            ? "scale-110 blur-2xl grayscale"
                            : "scale-100 blur-0 grayscale-0"
                        )}
                        onLoadingComplete={() => setIsImageLoading(false)}
                      />
                    </div>
                    {/* {items?.date?.value && (
                      <p className="text-[16px] font-normal text-[#9C9C9C] mt-4">
                        {moment(items?.date?.value).locale("en").format("MM-DD-YYYY")}{" "}
                      </p>
                    )} */}
                    <h4 className="text-[18px] font-medium text-neutral-800 my-4 ">
                      {items?.description?.value}
                    </h4>
                  </div>

                  <div className="flex relative z-40 flex-col">
                    <div className="flex  justify-end  relative z-100   gap-7 min-h-[33px] md:min-h-fit">
                      <button
                        className="-mt-[2px]"
                        onClick={(e) => {
                          e.stopPropagation();
                          downloadImage(items?.file, index, items?.description?.value);
                        }}
                        aria-label="Download image"
                      >
                        <span id={"download" + index}>
                          <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path d="M11.75 1C11.75 0.585786 11.4142 0.25 11 0.25C10.5858 0.25 10.25 0.585786 10.25 1V10.4619L10.2439 10.4548C10.0333 10.2062 9.82699 9.9434 9.63408 9.69769L9.58933 9.6407C9.39711 9.39596 9.19487 9.13885 9.03781 8.97726C8.74911 8.68023 8.27428 8.67349 7.97726 8.96219C7.68023 9.25089 7.67349 9.72572 7.96219 10.0227C8.05089 10.114 8.19651 10.2958 8.40971 10.5672L8.45677 10.6272C8.64683 10.8693 8.86981 11.1534 9.09954 11.4245C9.34574 11.715 9.62131 12.0168 9.89679 12.2515C10.0348 12.369 10.1904 12.485 10.3578 12.5746C10.5193 12.661 10.7417 12.75 11 12.75C11.2583 12.75 11.4807 12.661 11.6422 12.5746C11.8096 12.485 11.9652 12.369 12.1032 12.2515C12.3787 12.0168 12.6543 11.715 12.9005 11.4245C13.1302 11.1534 13.3531 10.8694 13.5432 10.6272L13.5903 10.5672C13.8035 10.2958 13.9491 10.114 14.0378 10.0227C14.3265 9.72572 14.3198 9.25089 14.0227 8.96219C13.7257 8.67349 13.2509 8.68023 12.9622 8.97726C12.8051 9.13885 12.6029 9.39596 12.4107 9.64069L12.366 9.69763C12.173 9.94336 11.9668 10.2061 11.7561 10.4548L11.75 10.4619V1Z" fill="#161616"/>
                            <path d="M4.77686 7.74947C5.19081 7.73466 5.51437 7.38709 5.49957 6.97314C5.48476 6.55919 5.13719 6.23562 4.72324 6.25043C2.33578 6.33583 0.182154 8.1485 0.251636 10.7047C0.267598 11.2919 0.483009 11.9786 0.813726 13.0328L0.857728 13.1731C1.78521 16.1325 3.43179 18.9597 7.22351 19.629C7.90939 19.75 8.66853 19.75 9.98165 19.75H12.0184C13.3315 19.75 14.0907 19.75 14.7766 19.629C18.5683 18.9597 20.2149 16.1325 21.1424 13.1731L21.1863 13.0329C21.5171 11.9786 21.7325 11.2919 21.7484 10.7047C21.8179 8.14849 19.6643 6.33582 17.2768 6.25043C16.8629 6.23562 16.5153 6.55919 16.5005 6.97314C16.4857 7.38709 16.8093 7.73466 17.2232 7.74947C18.9512 7.81128 20.2919 9.08521 20.249 10.6639C20.2395 11.013 20.1008 11.4809 19.711 12.7245C18.8448 15.4882 17.477 17.6291 14.5158 18.1518C13.9756 18.2472 13.3564 18.2499 11.9303 18.2499H10.0698C8.64367 18.2499 8.02449 18.2472 7.48425 18.1518C4.52307 17.6291 3.15523 15.4882 2.28908 12.7245C1.8993 11.4809 1.76057 11.013 1.75108 10.6639C1.70817 9.08522 3.0489 7.81128 4.77686 7.74947Z" fill="#161616"/>
                          </svg>

                        </span>
                        <span id={"loader" + index} className="hidden">
                          <div>
                            <div role="status">
                              <svg
                                aria-hidden="true"
                                className="inline w-[24px] h-[24px] text-gray-200 animate-spin dark:text-gray-600 fill-[#FF9619]"
                                viewBox="0 0 100 101"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                  fill="currentColor"
                                />
                                <path
                                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                  fill="currentFill"
                                />
                              </svg>
                              <span className="sr-only">Loading...</span>
                            </div>
                          </div>
                        </span>
                      </button>

                      {/* <div className="relative  xl:hidden">
                        <Popover className="flex gap-3">
                          <Popover.Button className="border-none outline-none">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg" aria-hidden={true} focusable="false">
                              <path
                                d="M18 8C19.6569 8 21 6.65685 21 5C21 3.34315 19.6569 2 18 2C16.3431 2 15 3.34315 15 5C15 6.65685 16.3431 8 18 8Z"
                                stroke="#423C3C"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M6 15C7.65685 15 9 13.6569 9 12C9 10.3431 7.65685 9 6 9C4.34315 9 3 10.3431 3 12C3 13.6569 4.34315 15 6 15Z"
                                stroke="#423C3C"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M18 22C19.6569 22 21 20.6569 21 19C21 17.3431 19.6569 16 18 16C16.3431 16 15 17.3431 15 19C15 20.6569 16.3431 22 18 22Z"
                                stroke="#423C3C"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M8.58984 13.51L15.4198 17.49"
                                stroke="#423C3C"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M15.4098 6.51001L8.58984 10.49"
                                stroke="#423C3C"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </Popover.Button>
                          <Popover.Panel className={`z-40 bg-[#FF9619] overflow-visible`}>
                            <div className="py-[0.2rem] flex w-full min-w-[180px] justify-evenly items-center">
                              <FacebookShareButton
                                url={process.env.NEXT_PUBLIC_SITECORE_API_HOST + items?.image + ""}
                                className="outline-none"
                              >
                                <div className="w-fit text-center">
                                  <svg
                                    width="14"
                                    height="24"
                                    viewBox="0 0 16 28"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg" aria-hidden={true} focusable="false">
                                    <path
                                      d="M14.5 1.5H10.75C9.0924 1.5 7.50269 2.15848 6.33058 3.33058C5.15848 4.50268 4.5 6.0924 4.5 7.75V11.5H0.75V16.5H4.5V26.5H9.5V16.5H13.25L14.5 11.5H9.5V7.75C9.5 7.41848 9.6317 7.10054 9.86612 6.86612C10.1005 6.6317 10.4185 6.5 10.75 6.5H14.5V1.5Z"
                                      stroke="white"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </div>
                              </FacebookShareButton>
                              <TwitterShareButton
                                url={process.env.NEXT_PUBLIC_SITECORE_API_HOST + items?.image + ""}
                                className="outline-none p-2 h-md:sm:p-4"
                              >
                                <div className="w-fit text-center">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="21"
                                    height="20"
                                    viewBox="0 0 21 20"
                                    fill="none" aria-hidden={true} focusable="false">
                                    <path
                                      d="M1.02122 0.632935L8.40258 11.1778L0.974609 19.7512H2.64635L9.14953 12.2451L14.4039 19.7512H20.0929L12.2962 8.61323L19.2101 0.632935H17.5384L11.5493 7.54597L6.71021 0.632935H1.02122ZM3.47964 1.94859H6.09317L17.6341 18.4354H15.0206L3.47964 1.94859Z"
                                      fill="#FFFFFF"
                                    />
                                  </svg>
                                </div>
                              </TwitterShareButton>

                              <WhatsappShareButton
                                url={process.env.NEXT_PUBLIC_SITECORE_API_HOST + items?.image}
                                className="outline-none"
                              >
                                <div className="w-fit text-center">
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg" aria-hidden={true} focusable="false">
                                    <path
                                      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.3789 2.27907 14.6926 2.78382 15.8877C3.06278 16.5481 3.20226 16.8784 3.21953 17.128C3.2368 17.3776 3.16334 17.6521 3.01642 18.2012L2 22L5.79877 20.9836C6.34788 20.8367 6.62244 20.7632 6.87202 20.7805C7.12161 20.7977 7.45185 20.9372 8.11235 21.2162C9.30745 21.7209 10.6211 22 12 22Z"
                                      stroke="white"
                                      stroke-width="1.5"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M8.58815 12.3773L9.45909 11.2956C9.82616 10.8397 10.2799 10.4153 10.3155 9.80826C10.3244 9.65494 10.2166 8.96657 10.0008 7.58986C9.91601 7.04881 9.41086 7 8.97332 7C8.40314 7 8.11805 7 7.83495 7.12931C7.47714 7.29275 7.10979 7.75231 7.02917 8.13733C6.96539 8.44196 7.01279 8.65187 7.10759 9.07169C7.51023 10.8548 8.45481 12.6158 9.91948 14.0805C11.3842 15.5452 13.1452 16.4898 14.9283 16.8924C15.3481 16.9872 15.558 17.0346 15.8627 16.9708C16.2477 16.8902 16.7072 16.5229 16.8707 16.165C17 15.8819 17 15.5969 17 15.0267C17 14.5891 16.9512 14.084 16.4101 13.9992C15.0334 13.7834 14.3451 13.6756 14.1917 13.6845C13.5847 13.7201 13.1603 14.1738 12.7044 14.5409L11.6227 15.4118"
                                      stroke="white"
                                      stroke-width="1.5"
                                    />
                                  </svg>
                                </div>
                              </WhatsappShareButton>
                              <EmailShareButton
                                url={process.env.NEXT_PUBLIC_SITECORE_API_HOST + items?.image}
                                className="outline-none"
                              >
                                <div className="w-fit text-center">
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg" aria-hidden={true} focusable="false">
                                    <path
                                      d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                                      stroke="#FBFBFB"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M22 6L12 13L2 6"
                                      stroke="#FBFBFB"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </div>
                              </EmailShareButton>
                            </div>
                          </Popover.Panel>
                        </Popover>
                      </div> */}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
      <div className="pagination flex justify-end">
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalItems={listData?.TotalItemsCount} // Replace with your total items count
          itemsPerPage={itemsPerPage} // Replace with your items per page count
          onPageChange={onPageChange}
          maxPages={5} // Maximum number of pages to display in pagination
          locale={props?.locale}
          lang={props?.lang}
          scrollToRef={container}
        />
      </div>


      <Transition appear show={isOpen} as={Fragment}>
        <Dialog  as="div" className="relative !z-[99999999] " onClose={()=>{}}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-[#0F2837] bg-opacity-75" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-hidden">
            <div className="flex min-h-full items-center justify-center text-center">
                <div className="absolute top-1 right-1 flex gap-2">
                      <button aria-label={isPlaying ? 'Pause' : 'Play'} onClick={()=> toggleAutoplay()} className="flex gap-2 items-center bg-[#1B8354] text-[#FFFFFF] py-2 px-4 rounded-lg" >
                        {isPlaying ?
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.95063 3.25C6.28579 3.24997 5.71289 3.24994 5.25416 3.31161C4.76252 3.37771 4.29126 3.52677 3.90901 3.90901C3.52677 4.29126 3.37771 4.76252 3.31161 5.25416C3.24994 5.71289 3.24997 6.28574 3.25 6.95058V17.0494C3.24997 17.7142 3.24994 18.2871 3.31161 18.7458C3.37771 19.2375 3.52677 19.7087 3.90901 20.091C4.29126 20.4732 4.76252 20.6223 5.25416 20.6884C5.71291 20.7501 6.28577 20.75 6.95064 20.75H7.04937C7.71424 20.75 8.2871 20.7501 8.74585 20.6884C9.23749 20.6223 9.70875 20.4732 10.091 20.091C10.4732 19.7087 10.6223 19.2375 10.6884 18.7458C10.7501 18.2871 10.75 17.7142 10.75 17.0494V6.95064C10.75 6.28577 10.7501 5.71291 10.6884 5.25416C10.6223 4.76252 10.4732 4.29126 10.091 3.90901C9.70875 3.52677 9.23749 3.37771 8.74585 3.31161C8.28712 3.24994 7.71427 3.24997 7.04943 3.25H6.95063ZM4.96968 4.96968C5.02677 4.91258 5.12873 4.84197 5.45403 4.79823C5.80091 4.7516 6.2717 4.75001 7.00001 4.75001C7.72831 4.75001 8.1991 4.7516 8.54598 4.79823C8.87128 4.84197 8.97324 4.91258 9.03034 4.96968C9.08743 5.02677 9.15804 5.12873 9.20178 5.45403C9.24841 5.80091 9.25001 6.2717 9.25001 7.00001V17C9.25001 17.7283 9.24841 18.1991 9.20178 18.546C9.15804 18.8713 9.08743 18.9732 9.03034 19.0303C8.97324 19.0874 8.87128 19.158 8.54598 19.2018C8.1991 19.2484 7.72831 19.25 7.00001 19.25C6.2717 19.25 5.80091 19.2484 5.45403 19.2018C5.12873 19.158 5.02677 19.0874 4.96968 19.0303C4.91258 18.9732 4.84197 18.8713 4.79823 18.546C4.7516 18.1991 4.75001 17.7283 4.75001 17V7.00001C4.75001 6.2717 4.7516 5.80091 4.79823 5.45403C4.84197 5.12873 4.91258 5.02677 4.96968 4.96968Z" fill="#FFFFFF"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.9506 3.25C16.2858 3.24997 15.7129 3.24994 15.2542 3.31161C14.7625 3.37771 14.2913 3.52677 13.909 3.90901C13.5268 4.29126 13.3777 4.76252 13.3116 5.25416C13.2499 5.7129 13.25 6.28576 13.25 6.95062V17.0494C13.25 17.7142 13.2499 18.2871 13.3116 18.7458C13.3777 19.2375 13.5268 19.7087 13.909 20.091C14.2913 20.4732 14.7625 20.6223 15.2542 20.6884C15.7129 20.7501 16.2858 20.75 16.9506 20.75H17.0494C17.7142 20.75 18.2871 20.7501 18.7458 20.6884C19.2375 20.6223 19.7087 20.4732 20.091 20.091C20.4732 19.7087 20.6223 19.2375 20.6884 18.7458C20.7501 18.2871 20.75 17.7143 20.75 17.0494V6.95064C20.75 6.28579 20.7501 5.7129 20.6884 5.25416C20.6223 4.76252 20.4732 4.29126 20.091 3.90901C19.7087 3.52677 19.2375 3.37771 18.7458 3.31161C18.2871 3.24994 17.7143 3.24997 17.0494 3.25H16.9506ZM14.9697 4.96968C15.0268 4.91258 15.1287 4.84197 15.454 4.79823C15.8009 4.7516 16.2717 4.75001 17 4.75001C17.7283 4.75001 18.1991 4.7516 18.546 4.79823C18.8713 4.84197 18.9732 4.91258 19.0303 4.96968C19.0874 5.02677 19.158 5.12873 19.2018 5.45403C19.2484 5.80091 19.25 6.2717 19.25 7.00001V17C19.25 17.7283 19.2484 18.1991 19.2018 18.546C19.158 18.8713 19.0874 18.9732 19.0303 19.0303C18.9732 19.0874 18.8713 19.158 18.546 19.2018C18.1991 19.2484 17.7283 19.25 17 19.25C16.2717 19.25 15.8009 19.2484 15.454 19.2018C15.1287 19.158 15.0268 19.0874 14.9697 19.0303C14.9126 18.9732 14.842 18.8713 14.7982 18.546C14.7516 18.1991 14.75 17.7283 14.75 17V7.00001C14.75 6.2717 14.7516 5.80091 14.7982 5.45403C14.842 5.12873 14.9126 5.02677 14.9697 4.96968Z" fill="#FFFFFF"/>
                          </svg>
                        : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M13.852 6.28676L13.9405 6.33706C15.5735 7.26475 16.8567 7.99375 17.7709 8.66154C18.6913 9.33392 19.3721 10.0367 19.6159 10.9632C19.7947 11.6427 19.7947 12.3574 19.6159 13.0369C19.3721 13.9634 18.6913 14.6662 17.7709 15.3386C16.8567 16.0064 15.5735 16.7354 13.9406 17.663L13.852 17.7134C12.2746 18.6095 11.033 19.3149 10.0232 19.7444C9.0053 20.1774 8.07729 20.3968 7.17536 20.1412C6.51252 19.9534 5.90941 19.5969 5.42356 19.1067C4.76419 18.4414 4.49951 17.522 4.37429 16.4154C4.24998 15.317 4.24999 13.879 4.25 12.0502V11.95C4.24999 10.1211 4.24998 8.68315 4.37429 7.5847C4.49951 6.47816 4.76419 5.55867 5.42356 4.89341C5.90941 4.40323 6.51252 4.04672 7.17536 3.8589C8.07729 3.60331 9.0053 3.82275 10.0232 4.25571C11.033 4.68522 12.2746 5.3906 13.852 6.28676ZM9.43611 5.63604C8.51385 5.24377 7.98374 5.18888 7.58431 5.30207C7.17108 5.41917 6.79377 5.64179 6.48892 5.94935C6.19206 6.24887 5.97861 6.74743 5.86477 7.75337C5.75115 8.75741 5.75 10.1102 5.75 12.0001C5.75 13.8899 5.75115 15.2427 5.86477 16.2467C5.97861 17.2527 6.19206 17.7513 6.48892 18.0508C6.79377 18.3583 7.17108 18.581 7.58431 18.6981C7.98374 18.8112 8.51385 18.7564 9.43611 18.3641C10.3571 17.9724 11.524 17.3108 13.1553 16.384C14.8421 15.4257 16.0497 14.7383 16.8861 14.1273C17.7244 13.5149 18.0557 13.0717 18.1653 12.6552C18.2782 12.2259 18.2782 11.7742 18.1653 11.345C18.0557 10.9285 17.7244 10.4852 16.8861 9.8728C16.0497 9.26183 14.8421 8.57445 13.1553 7.6161C11.524 6.68934 10.3571 6.02776 9.43611 5.63604Z" fill="white"/>
                        </svg>}
                        {isPlaying ? 'Pause': 'Play'}
                        </button>
                      <button aria-label="Close grid view" className="flex gap-2 items-center bg-neutral-100 text-primary-1000  py-2 px-4 rounded-lg" onClick={()=> closeModal()}>
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.75 12.0572V11.9428C1.74999 9.75212 1.74998 8.03144 1.93059 6.68802C2.11568 5.31137 2.50271 4.21911 3.36091 3.36091C4.21911 2.50271 5.31137 2.11568 6.68802 1.93059C8.03144 1.74998 9.75211 1.74999 11.9428 1.75H12.0572C14.2479 1.74999 15.9686 1.74998 17.312 1.93059C18.6886 2.11568 19.7809 2.50271 20.6391 3.36091C21.4973 4.21911 21.8843 5.31136 22.0694 6.68802C22.25 8.03143 22.25 9.7521 22.25 11.9428V12.0572C22.25 14.2479 22.25 15.9686 22.0694 17.312C21.8843 18.6886 21.4973 19.7809 20.6391 20.6391C19.7809 21.4973 18.6886 21.8843 17.312 22.0694C15.9686 22.25 14.2479 22.25 12.0572 22.25H11.9428C9.75212 22.25 8.03144 22.25 6.68802 22.0694C5.31137 21.8843 4.21911 21.4973 3.36091 20.6391C2.50272 19.7809 2.11568 18.6886 1.93059 17.312C1.74998 15.9686 1.74999 14.2479 1.75 12.0572ZM3.41722 17.1121C3.57994 18.3224 3.88853 19.0454 4.42157 19.5784C4.95462 20.1115 5.67757 20.4201 6.8879 20.5828C7.00502 20.5985 7.12565 20.6128 7.25 20.6257L7.25 15.75H3.30067C3.32544 16.2528 3.36232 16.7038 3.41722 17.1121ZM8.75 15.75L8.75 20.7196C9.66079 20.7495 10.7292 20.75 12 20.75C13.2708 20.75 14.3392 20.7495 15.25 20.7196V15.75L8.75 15.75ZM8.75 14.25V9.75H15.25L15.25 14.25L8.75 14.25ZM7.25 9.75V14.25H3.25877C3.25022 13.5785 3.25 12.8327 3.25 12C3.25 11.1673 3.25022 10.4215 3.25877 9.75H7.25ZM8.75 8.25L15.25 8.25V3.28038C14.3392 3.2505 13.2708 3.25 12 3.25C10.7292 3.25 9.66079 3.2505 8.75 3.28038L8.75 8.25ZM7.25 3.37429L7.25 8.25H3.30067C3.32544 7.74721 3.36232 7.29624 3.41722 6.8879C3.57994 5.67757 3.88853 4.95462 4.42157 4.42157C4.95462 3.88853 5.67757 3.57994 6.88789 3.41722C7.00502 3.40147 7.12565 3.38721 7.25 3.37429ZM17.1121 20.5828C16.995 20.5985 16.8744 20.6128 16.75 20.6257V15.75H20.6993C20.6746 16.2528 20.6377 16.7038 20.5828 17.1121C20.4201 18.3224 20.1115 19.0454 19.5784 19.5784C19.0454 20.1115 18.3224 20.4201 17.1121 20.5828ZM20.7412 14.25H16.75L16.75 9.75H20.7412C20.7498 10.4215 20.75 11.1673 20.75 12C20.75 12.8327 20.7498 13.5785 20.7412 14.25ZM20.6993 8.25H16.75V3.37429C16.8744 3.38721 16.995 3.40147 17.1121 3.41722C18.3224 3.57994 19.0454 3.88853 19.5784 4.42157C20.1115 4.95462 20.4201 5.67757 20.5828 6.88789C20.6377 7.29624 20.6746 7.74721 20.6993 8.25Z" fill="#161616"/>
                          </svg>
                        Grid</button>
                        <button aria-label="Close" className="flex gap-2 items-center bg-neutral-100 text-primary-1000  py-2 px-4 rounded-lg" onClick={()=> closeModal()}>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M0.46967 0.46967C0.762563 0.176777 1.23744 0.176777 1.53033 0.46967L8 6.93934L14.4697 0.46967C14.7626 0.176777 15.2374 0.176777 15.5303 0.46967C15.8232 0.762563 15.8232 1.23744 15.5303 1.53033L9.06066 8L15.5303 14.4697C15.8232 14.7626 15.8232 15.2374 15.5303 15.5303C15.2374 15.8232 14.7626 15.8232 14.4697 15.5303L8 9.06066L1.53033 15.5303C1.23744 15.8232 0.762563 15.8232 0.46967 15.5303C0.176777 15.2374 0.176777 14.7626 0.46967 14.4697L6.93934 8L0.46967 1.53033C0.176777 1.23744 0.176777 0.762563 0.46967 0.46967Z" fill="#161616"/>
                        </svg>
                        Cancel</button>
                </div>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="h-auto xl:h-screen transform overflow-hidden   bg-transparent  text-left align-middle  transition-all">
                  <div
                    className={`flex justify-center h-full w-full items-center flex-col ${
                      props?.locale == props?.lang ? "rtl" : ""
                    }`}
                  >

                    <div className={`flex flex-row-reverse`}>
                      <div className="flex w-fit h-auto lg:h-full gap-4">
                        <div
                          className={`h-auto hidden justify-center items-center pb-16 md:flex lg:pb-36`}
                        >
                          <button
                            aria-label="Previous slide"
                            className={`transition-opacity duration-300 ease-in-out
                          ${swiper?.isBeginning ? "opacity-60" : "cursor-pointer opacity-100"}`}
                            onClick={() => {
                              swiper?.slidePrev();
                            }}
                            disabled={swiper?.isBeginning}
                          >
                            <svg width="49" height="48" viewBox="0 0 49 48"
                              fill="none" xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                            >
                              <rect x="0.703125" width="48" height="48" rx="24" fill="#1B8354"/>
                              <path d="M27.7034 32.6695C27.5134 32.6695 27.3234 32.5995 27.1734 32.4495L20.6534 25.9295C19.5934 24.8695 19.5934 23.1295 20.6534 22.0695L27.1734 15.5495C27.4634 15.2595 27.9434 15.2595 28.2334 15.5495C28.5234 15.8395 28.5234 16.3195 28.2334 16.6095L21.7134 23.1295C21.2334 23.6095 21.2334 24.3895 21.7134 24.8695L28.2334 31.3895C28.5234 31.6795 28.5234 32.1595 28.2334 32.4495C28.0834 32.5895 27.8934 32.6695 27.7034 32.6695Z" fill="white"/>
                            </svg>
                          </button>
                        </div>
                        <div className="w-[359px] sm:w-[574px] h-md:lg:w-[844px] !h-auto">
                          <Swiper
                            onInit={(ev) => {
                              setSwiper(ev as any);
                              // setThumbsSwiper(ev)
                            }}
                            dir={props?.locale == props?.lang ? "rtl" : ""}
                            key={props?.locale == props?.lang ? "true" : "false"}
                            onSwiper={handleSwiperUpdate}
                            slidesPerView={1}
                            spaceBetween={0}
                            speed={900}
                            allowTouchMove={true}
                            resistanceRatio={0}
                            navigation={false}
                            mousewheel={{ thresholdDelta: 100, forceToAxis: false }}
                            thumbs={{ swiper: thumbsSwiper }}
                            initialSlide={selectedSlide}
                            onSlideChange={handleSlideChange}
                            modules={[Navigation, Mousewheel, Thumbs, Autoplay]}
                            autoplay={{
                              delay: 3000, // Time between slides in ms
                              disableOnInteraction: false, // Keep autoplay even after user interaction
                            }}
                            loop={true} // Optional: loop the slides
                            className={`
                            [&>.swiper-button-next]:scale-50 [&>.swiper-button-next]:text-white
                          [&>.swiper-button-prev]:text-white [&>.swiper-button-prev]:scale-50
                          [&>.swiper-button-disabled]:!opacity-0 [&>.swiper-button-disabled]:transition-opacity
                          [&>.swiper-button-disabled]:ease-out [&>.swiper-button-disabled]:duration-300
                          [&>.swiper-button-prev]:hidden [&>.swiper-button-next]:hidden
                          md:[&>.swiper-button-prev]:block md:[&>.swiper-button-next]:block
                          ${
                            props?.locale == props?.lang
                              ? "xl:[&>.swiper-button-next]:!left-[20px] xl:[&>.swiper-button-prev]:!right-[20px]"
                              : "xl:[&>.swiper-button-next]:right-[20px] xl:[&>.swiper-button-prev]:left-[20px]"
                          }
                          `}
                          >
                            {listData?.CulturalLens?.map((item: any, index: number) => {
                              return (
                                <SwiperSlide key={index}>
                                  <div className="relative h-[282px] w-[424px] sm:w-[574px] sm:h-[382px] h-md:lg:w-[844px] h-md:lg:h-[562px] text-center m-auto ">
                                    <Image
                                      src={process.env.NEXT_PUBLIC_SITECORE_API_HOST + item?.image}
                                      alt={item?.description?.value || item?.title?.value || `Cultural lens image ${index + 1}`}
                                      className="aspect-[1.5]"
                                      layout="fill"
                                      objectPosition={"center"}
                                      objectFit="contain"
                                    />
                                  </div>
                                </SwiperSlide>
                              );
                            })}
                          </Swiper>
                          <Swiper
                            onSwiper={setThumbsSwiper}
                            spaceBetween={10}
                            slidesPerView={5}
                            freeMode={true}
                            resistanceRatio={0}
                            mousewheel={{ thresholdDelta: 100, forceToAxis: false }}
                            dir={props?.locale == props?.lang ? "rtl" : ""}
                            key={props?.locale == props?.lang ? "true" : "false"}
                            // watchSlidesProgress={true}
                            modules={[FreeMode, Thumbs, Mousewheel]}
                            className={`cursor-grab thumb-swiper sm:mt-2`}
                          >
                            {listData?.CulturalLens?.map((item: any, index: number) => {
                              return (
                                <SwiperSlide key={index}>
                                  <div className="relative overflow-hidden h-[54px] w-[82px] sm:w-[199px] border-red-400 sm:h-[72px] h-md:lg:w-[159px] h-md:lg:h-[105px] text-center m-auto ">
                                    <div className="swiper-thumb-overlay absolute inset-0 w-full h-full bg-brand-50 z-50" />
                                    <Image
                                      src={process.env.NEXT_PUBLIC_SITECORE_API_HOST + item?.image}
                                      alt={item?.description?.value || item?.title?.value || `Cultural lens thumbnail ${index + 1}`}
                                      className="aspect-[1.5]"
                                      layout="fill"
                                      objectPosition={"center"}
                                      objectFit="contain"
                                    />
                                  </div>
                                </SwiperSlide>
                              );
                            })}
                          </Swiper>
                        </div>
                        <div
                          className={`h-auto hidden justify-center items-center pb-16 md:flex lg:pb-36`}
                        >
                            <button
                              aria-label="Next slide"
                              className={`transition-opacity duration-300 ease-in-out
                            ${swiper?.isEnd ? "opacity-60" : "cursor-pointer opacity-100"}`}
                              onClick={() => {
                                swiper?.slideNext();
                              }}
                              disabled={swiper?.isEnd}
                            >
                              <svg width="49" height="48" viewBox="0 0 49 48"
                                fill="none" xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                              >
                                <rect x="0.295898" width="48" height="48" rx="24" fill="#1B8354"/>
                                <path d="M21.2055 32.6695C21.0155 32.6695 20.8255 32.5995 20.6755 32.4495C20.3855 32.1595 20.3855 31.6795 20.6755 31.3895L27.1955 24.8695C27.6755 24.3895 27.6755 23.6095 27.1955 23.1295L20.6755 16.6095C20.3855 16.3195 20.3855 15.8395 20.6755 15.5495C20.9655 15.2595 21.4455 15.2595 21.7355 15.5495L28.2555 22.0695C28.7655 22.5795 29.0555 23.2695 29.0555 23.9995C29.0555 24.7295 28.7755 25.4195 28.2555 25.9295L21.7355 32.4495C21.5855 32.5895 21.3955 32.6695 21.2055 32.6695Z" fill="white"/>
                              </svg>
                            </button>
                        </div>
                      </div>
                      {/* close and share btns */}
                      {/* <div
                        className={`xl:block hidden max-w-[3rem] sm:max-w-fit overflow-x-hidden   !overflow-y-auto ${
                          props?.locale == props?.lang ? "xl:ml-2 ml-3" : "xl:mr-2 mr-3"
                        }  `}
                      >
                        <div
                          onClick={closeModal}
                          className="bg-brand-100 p-2 md:py-[0.5rem] h-md:sm:p-4 w-full flex justify-center h-md:mb-7 cursor-pointer"
                        >
                          <div>
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg" aria-hidden={true} focusable="false">
                              <path
                                d="M18 6L6 18"
                                stroke="white"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M6 6L18 18"
                                stroke="white"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </div>
                        </div>
                        <div className="">
                          <div className="bg-[#FF9619] flex flex-col justify-center items-center mt-6">
                            <div className="flex flex-col justify-center items-center">
                              <div
                                className="p-2 md:py-[0.5rem] h-md:sm:p-4 cursor-pointer"
                                onClick={() => {
                                  setShareModal(!shareModal);
                                }}
                              >
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg" aria-hidden={true} focusable="false">
                                  <path
                                    d="M18 8C19.6569 8 21 6.65685 21 5C21 3.34315 19.6569 2 18 2C16.3431 2 15 3.34315 15 5C15 6.65685 16.3431 8 18 8Z"
                                    stroke="#F2F2F2"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M6 15C7.65685 15 9 13.6569 9 12C9 10.3431 7.65685 9 6 9C4.34315 9 3 10.3431 3 12C3 13.6569 4.34315 15 6 15Z"
                                    stroke="#F2F2F2"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M18 22C19.6569 22 21 20.6569 21 19C21 17.3431 19.6569 16 18 16C16.3431 16 15 17.3431 15 19C15 20.6569 16.3431 22 18 22Z"
                                    stroke="#F2F2F2"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M8.58984 13.51L15.4198 17.49"
                                    stroke="#F2F2F2"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                  <path
                                    d="M15.4098 6.51001L8.58984 10.49"
                                    stroke="#F2F2F2"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  />
                                </svg>
                              </div>
                              <div
                                id="shareWrp"
                                className={`overflow-hidden ${
                                  shareModal ? "flex" : "hidden"
                                } flex-col items-center w-[40px] md:w-[56px]`}
                              >
                                <FacebookShareButton
                                  url={
                                    process.env.NEXT_PUBLIC_SITECORE_API_HOST +
                                    listData?.CulturalLens[activeSlideIndex]?.image +
                                    ""
                                  }
                                  className="outline-none"
                                >
                                  <div className="w-full md:py-[0.5rem] h-md:py-4  text-center">
                                    <svg
                                      width="14"
                                      height="24"
                                      viewBox="0 0 16 28"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="w-full" aria-hidden={true} focusable="false">
                                      <path
                                        d="M14.5 1.5H10.75C9.0924 1.5 7.50269 2.15848 6.33058 3.33058C5.15848 4.50268 4.5 6.0924 4.5 7.75V11.5H0.75V16.5H4.5V26.5H9.5V16.5H13.25L14.5 11.5H9.5V7.75C9.5 7.41848 9.6317 7.10054 9.86612 6.86612C10.1005 6.6317 10.4185 6.5 10.75 6.5H14.5V1.5Z"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  </div>
                                </FacebookShareButton>
                                <TwitterShareButton
                                  url={
                                    process.env.NEXT_PUBLIC_SITECORE_API_HOST +
                                    listData?.CulturalLens[activeSlideIndex]?.image +
                                    ""
                                  }
                                  className="outline-none p-2 h-md:sm:p-4"
                                >
                                  <div className="w-full md:py-[0.5rem] h-md:py-4 text-center">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="21"
                                      height="20"
                                      viewBox="0 0 21 20"
                                      fill="none" aria-hidden={true} focusable="false">
                                      <path
                                        d="M1.02122 0.632935L8.40258 11.1778L0.974609 19.7512H2.64635L9.14953 12.2451L14.4039 19.7512H20.0929L12.2962 8.61323L19.2101 0.632935H17.5384L11.5493 7.54597L6.71021 0.632935H1.02122ZM3.47964 1.94859H6.09317L17.6341 18.4354H15.0206L3.47964 1.94859Z"
                                        fill="#FFFFFF"
                                      />
                                    </svg>
                                  </div>
                                </TwitterShareButton>
                                <WhatsappShareButton
                                  url={
                                    process.env.NEXT_PUBLIC_SITECORE_API_HOST +
                                    listData?.CulturalLens[activeSlideIndex]?.image +
                                    ""
                                  }
                                  className="outline-none"
                                >
                                  <div className="w-full md:py-[0.5rem] h-md:py-4 text-center">
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg" aria-hidden={true} focusable="false">
                                      <path
                                        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 13.3789 2.27907 14.6926 2.78382 15.8877C3.06278 16.5481 3.20226 16.8784 3.21953 17.128C3.2368 17.3776 3.16334 17.6521 3.01642 18.2012L2 22L5.79877 20.9836C6.34788 20.8367 6.62244 20.7632 6.87202 20.7805C7.12161 20.7977 7.45185 20.9372 8.11235 21.2162C9.30745 21.7209 10.6211 22 12 22Z"
                                        stroke="white"
                                        stroke-width="1.5"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M8.58815 12.3773L9.45909 11.2956C9.82616 10.8397 10.2799 10.4153 10.3155 9.80826C10.3244 9.65494 10.2166 8.96657 10.0008 7.58986C9.91601 7.04881 9.41086 7 8.97332 7C8.40314 7 8.11805 7 7.83495 7.12931C7.47714 7.29275 7.10979 7.75231 7.02917 8.13733C6.96539 8.44196 7.01279 8.65187 7.10759 9.07169C7.51023 10.8548 8.45481 12.6158 9.91948 14.0805C11.3842 15.5452 13.1452 16.4898 14.9283 16.8924C15.3481 16.9872 15.558 17.0346 15.8627 16.9708C16.2477 16.8902 16.7072 16.5229 16.8707 16.165C17 15.8819 17 15.5969 17 15.0267C17 14.5891 16.9512 14.084 16.4101 13.9992C15.0334 13.7834 14.3451 13.6756 14.1917 13.6845C13.5847 13.7201 13.1603 14.1738 12.7044 14.5409L11.6227 15.4118"
                                        stroke="white"
                                        stroke-width="1.5"
                                      />
                                    </svg>
                                  </div>
                                </WhatsappShareButton>
                                <EmailShareButton
                                  url={
                                    process.env.NEXT_PUBLIC_SITECORE_API_HOST +
                                    listData?.CulturalLens[activeSlideIndex]?.image +
                                    ""
                                  }
                                  className="outline-none"
                                >
                                  <div className="w-full md:py-[0.5rem] h-md:py-4 text-center">
                                    <svg
                                      width="20"
                                      height="20"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg" aria-hidden={true} focusable="false">
                                      <path
                                        d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                                        stroke="#FBFBFB"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M22 6L12 13L2 6"
                                        stroke="#FBFBFB"
                                        stroke-width="1.5"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  </div>
                                </EmailShareButton>
                              </div>
                            </div>
                            <div className="w-[46px] h-[1px] bg-white" />
                            <button
                              onClick={() =>
                                downloadImage(
                                  listData?.CulturalLens[activeSlideIndex]?.image + "",
                                  -1,
                                  listData?.CulturalLens[activeSlideIndex]?.description?.value
                                )
                              }
                            >
                              <div className="md:py-[0.5rem] h-md:py-4">
                                <span id="download-1">
                                  <svg
                                    width="25"
                                    height="25"
                                    viewBox="0 0 25 25"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg" aria-hidden={true} focusable="false">
                                    <path
                                      d="M12.5002 15.1042V4.6875M12.5002 15.1042C11.7708 15.1042 10.408 13.0268 9.896 12.5M12.5002 15.1042C13.2295 15.1042 14.5924 13.0268 15.1043 12.5"
                                      stroke="white"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                    <path
                                      d="M20.8332 17.1875C20.8332 19.7729 20.2936 20.3125 17.7082 20.3125H7.2915C4.70609 20.3125 4.1665 19.7729 4.1665 17.1875"
                                      stroke="white"
                                      stroke-width="1.5"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    />
                                  </svg>
                                </span>
                                <span id={"loader-1"} className="hidden">
                                  <div>
                                    <div role="status">
                                      <svg
                                        aria-hidden="true"
                                        className="inline w-[24px] h-[24px] text-gray-200 animate-spin dark:text-gray-600 fill-[#FF9619]"
                                        viewBox="0 0 100 101"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                          fill="currentFill"
                                        />
                                      </svg>
                                      <span className="sr-only">Loading...</span>
                                    </div>
                                  </div>
                                </span>
                              </div>
                            </button>
                          </div>
                        </div>
                      </div> */}
                    </div>
                    <div className="flex justify-start items-center gap-4 mt-[30px] self-start md:hidden">
                      <div
                        className="bg-brand-100 p-1 group hover:bg-brand-1600 cursor-pointer transition-colors duration-500 ease-in-out "
                        onClick={() => swiper?.slidePrev()}
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className={`${props?.locale == props?.lang ? "" : "rotate-180"}`} aria-hidden={true} focusable="false">
                          <path
                            d="M7.5 15L12.5 10L7.5 5"
                            stroke="#F2F2F2"
                            className="group-hover:stroke-[#6A7982]"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                      <div className="text-white font-medium">
                        {activeSlideIndex + 1} - {listData?.TotalItemsCount}
                      </div>
                      <div
                        className="bg-brand-100 p-1 group hover:bg-brand-1600 cursor-pointer transition-colors duration-500 ease-in-out "
                        onClick={() => swiper?.slideNext()}
                      >
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className={`${props?.locale == props?.lang ? "rotate-180" : ""}`} aria-hidden={true} focusable="false">
                          <path
                            d="M7.5 15L12.5 10L7.5 5"
                            stroke="#F2F2F2"
                            className="group-hover:stroke-[#6A7982]"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
    </div>
  );
};

export default withDatasourceCheck()<CulturalLensProps>(CulturalLens);
